import { CIcon } from '@coreui/icons-react'
import {
  CAlert, CButton, CButtonGroup, CCard, CCardBody, CCardHeader, CCol, CDataTable, CRow, CTooltip
} from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { fs } from '../firebase'
import Notify from '../utils/Notify'
import AddPageModal from './modals/AddPageModal'
import ConfirmationModal from './modals/ConfirmationModal'
import moment from 'moment'

export default function Pages() {
  const [pages, setPages] = useState([])
  const [selectedPage, setSelectedPage] = useState()
  const [showPageModal, setShowPageModal] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const pageRef = fs.collection('pages')

  async function deletePage() {
    if (selectedPage == null) return
    try {
      await fs.collection('pages').doc(selectedPage.id).delete()
      setShowConfirmModal(false)
      setSelectedPage(null)
      Notify.success('Page deleted successfully.')
    } catch (error) {
      Notify.error('Something went wrong, Please try again later.')
    }
  }
  useEffect(() => {
    pageRef
      .orderBy('createdAt', 'desc')
      .onSnapshot((querySnapshot) => {
        const items = querySnapshot.docs.map(doc => doc.data())
        setPages(items)
        console.log('Snapshot')
      })
  }, [])

  return (
    <>
      <CRow>
        <CCol>
          <h4>Pages</h4>
        </CCol>
        <CCol className="text-right">
          <CButton color="dark" className="btn-sm"
            onClick={() => setShowPageModal(!showPageModal)} ><CIcon name="cil-plus" /> Add Page</CButton>
        </CCol>
      </CRow>

      <CRow className={'mt-3'}>
        <CCol xs="12" lg="12">
          <CCard>
            <CCardHeader>
              Pages
            </CCardHeader>
            <CCardBody>
              <CDataTable
                items={pages}
                striped
                fields={[
                  {
                    key: 'id',
                    label: '#ID'
                  }, {
                    key: 'name',
                    label: 'Name'
                  }, {
                    key: 'createdAt',
                    label: 'Created Date'
                  }, {
                    key: 'actions',
                    label: 'Actions',
                  }
                ]}
                scopedSlots={{
                  'createdAt': (item) => {
                    return <td>{moment(item.createdAt.toDate()).format('DD/MM/YYYY')}</td>
                  },
                  'actions': (item) => {
                    return (
                      <td>
                        <CButtonGroup className="w-100">
                          <CTooltip content="Edit Page" placement="bottom">
                            <CButton color="dark" variant="outline"
                              onClick={() => {
                                setSelectedPage(item)
                                setShowPageModal(true)
                              }}>
                              <CIcon name="cil-pen-alt"></CIcon>
                            </CButton>
                          </CTooltip>
                          <CTooltip content="Delete Page" placement="bottom">
                            <CButton color="danger" variant="outline"
                              onClick={() => {
                                setSelectedPage(item)
                                setShowConfirmModal(true)
                              }}>
                              <CIcon name="cil-trash"></CIcon>
                            </CButton>
                          </CTooltip>

                        </CButtonGroup>
                      </td>
                    )
                  },

                }}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      {
        showPageModal &&
        <AddPageModal
          show={showPageModal}
          page={selectedPage}
          onClose={() => {
            setSelectedPage(null)
            setShowPageModal(false)
          }
          }
        />
      }
      {
        showConfirmModal &&
        (
          <ConfirmationModal
            show={showConfirmModal}
            title={`Confirm delete "${selectedPage.name}"?`}
            content={() =>
            (
              <>
                <CAlert color="warning" className="w-100">
                  Are you sure you want to delete this Page?
                </CAlert>
              </>
            )
            }
            onClose={() => {
              setShowConfirmModal(false)
            }}
            confirmText='Delete'
            onConfirm={() => {
              deletePage()
            }}
          />
        )
      }
    </>
  )
}
